import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SignInJwtService } from 'src/app/services/signIn-jwt/signIn-jwt.service';
import { IHttpResult } from '@leandredev/common_js';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  animations: [fadeInUpAnimation]
})
export class ForgotPasswordComponent {
  public mailSendedWithSuccess = false;

  public formGroup: FormGroup<{ email: FormControl<string> }> = this.formBuilder.group({
    email: ['', Validators.required]
  });

  constructor(private formBuilder: FormBuilder, private signInJwtService: SignInJwtService, private snackBar: MatSnackBar) {}

  public send(): void {
    if (!this.formGroup.valid) {
      return;
    }

    this.signInJwtService.lostPassword(this.formGroup.get('email')?.value, `${window.location.origin}/reset-password/`).subscribe((result) => {
      this.displayResetPasswodResult(result);
    });
  }

  private displayResetPasswodResult(result: IHttpResult<void>): void {
    switch (result.code) {
      case 200:
        this.snackBar.open('Votre demande a été prise en compte. Vous allez recevoir un email avec les intructions à suivre', 'X', {
          panelClass: 'succes',
          verticalPosition: 'bottom'
        });
        break;
      case 500:
        this.snackBar.open(`Aucun utilisateur ne correspond à l'adresse email ${this.formGroup.get('email')?.value}`, '×', {
          panelClass: 'error',
          verticalPosition: 'bottom'
        });
        break;
    }
  }
}
